import React, { useState } from "react";
import * as moment from "moment";
import { Table } from "reactstrap";
import TooltipMaterial from "@material-ui/core/Tooltip";
import { useDispatch } from "react-redux";
import DownloadInvoiceIcon from "web/assets/svg/DownloadInvoiceIcon";
import { invoiceDownload } from "redux/actions/adminPtPlusOrderRequests";
import { InvoiceTableContainer, PaidDateModal } from "./InvoiceTableStyle";
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { Modal, ModalBody } from 'reactstrap';
import DatePicker from "../headingSection/DatePicker";

const InvoiceTable = (props) => {
  const { callBackInvoice } = props

  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  let dateLimit = new Date()
  dateLimit.setDate(dateLimit.getDate() - 60);
  let todayDate = new Date();
  todayDate = moment(todayDate).format("MM/DD/YYYY")
  const [defaultDateValue, setDefaultDateValue] = useState(new Date(todayDate))
  let tempFromDate = (moment(todayDate)).valueOf()
  tempFromDate = Math.trunc(tempFromDate / 1000) + 61200
  const [paidDateValue, setPaidDateValue] = useState(tempFromDate)
  const [payModal, setPayModal] = useState(false)
  const [apiPayloadTempSave, setApiPayloadTempSave] = useState()

  //DownloadInvoice function
  const downLoadInvoice = async (invoiceId, locationId) => {
    let response = await dispatch(invoiceDownload(token, invoiceId, locationId));

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "invoice.pdf");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <InvoiceTableContainer>
      <Table responsive style={{ width: "100%" }}>
        <thead>
          <tr>
            {props?.headerArr.map((items, index) => (
              <th key={index}>{items}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props?.orderResponse?.invoiceList?.map((items, index) => (
            <>
              <tr
                className={index % 2 === 0 ? "odd-rows set-border" : "even-rows set-border"}
                key={index}
              >
                <td>
                  {items.locationName}{" "}
                </td>
                <td>
                  {items?.location?.city ? <>{items?.location?.city}, {items?.location?.state.length === 2 ? items?.location?.state : stateConvert(items?.location?.state)}</> : "NA"}
                </td>
                <td>
                  {items.invoiceNumber}{" "}
                </td>
                <td style={{ cursor: 'pointer' }}>
                  {items.associatedOrderDetails ?
                    <TooltipMaterial
                      placement="top"
                      arrow
                      title={items.associatedOrderDetails?.orders?.map(val => val.orderId)?.join(', ')}
                      enterTouchDelay={0}
                    >
                      <p style={{ margin: 0 }}>{items.associatedOrderDetails?.orderAssociate === 'Single'
                        ? items.associatedOrderDetails?.orders?.map(val => val.orderId)?.join(', ')
                        : 'MULTIPLE'}{" "}</p>
                    </TooltipMaterial>
                    :
                    'NA'
                  }
                </td>
                <td style={{ cursor: 'pointer' }}>
                  {items.associatedOrderDetails ?
                    <TooltipMaterial
                      placement="top"
                      arrow
                      title={items.associatedOrderDetails?.orders?.map(val => val.poNumber)?.join(', ')}
                      enterTouchDelay={0}
                    >
                      <p style={{ margin: 0 }}>{items.associatedOrderDetails?.orderAssociate === 'Single'
                        ? (items.associatedOrderDetails?.orders?.map(val => val.poNumber)?.join(', ') || 'NA')
                        : 'MULTIPLE'}{" "}</p>
                    </TooltipMaterial>
                    :
                    'NA'
                  }
                </td>
                <td>
                  {moment(items.invoiceDate * 1000).format("MM/DD/YYYY")}{" "}
                </td>

                <td>
                  {items.invoiceFromDate}{" "}
                  -{" "}
                  {items.invoiceToDate}{" "}
                </td>
                <td>
                  {items.numberOfLoads}{" "}
                </td>
                <td>
                  {"$" + items.totalAmount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                </td>
                <td>
                  {items?.status === "PAID" ? (
                    <button style={{
                      padding: "5px 15px",
                      background: "#61AE24",
                      borderRadius: "4px",
                      border: "none",
                      fontFamily: 'Latoregular',
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "15px",
                      lineHeight: "18px",
                      color: "#FFFFFF",
                      textAlign: "center",
                      cursor: 'default'
                    }}
                      onClick={() => {
                      }}
                    >Paid</button>
                  ) : (
                    <button style={{
                      padding: "5px 15px",
                      background: "#fff",
                      borderRadius: "4px",
                      border: "1px solid",
                      fontFamily: 'Latoregular',
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "15px",
                      lineHeight: "18px",
                      color: "black",
                      textAlign: "center"
                    }}
                      onClick={() => {
                        setPayModal(true)
                        setApiPayloadTempSave(items)
                      }}>Mark Paid</button>
                  )}{" "}
                </td>
                <td>
                  {items.paidDate ? moment(items.paidDate * 1000).format("MM/DD/YYYY") : ""}{" "}
                </td>
                <td>
                  <div
                    onClick={() => {
                      downLoadInvoice(
                        items.invoiceNumber,
                        items.locationId
                      )
                    }
                    }
                  >
                    <DownloadInvoiceIcon />
                  </div>
                </td>
              </tr>
            </>
          ))}{" "}
        </tbody>
      </Table>
      <>
        <Modal isOpen={payModal} centered={true}>
          <PaidDateModal>
            <ModalBody>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                <p>Are you sure you want to mark as Paid?</p>
                <DatePicker
                  name="fromDate"
                  minDOBirth={dateLimit}
                  maxDOBirth={todayDate}
                  value={defaultDateValue}
                  callBackFun={(date) => {
                    setDefaultDateValue(date)
                    let tempFromDate = moment(date).format("MM/DD/YYYY")
                    tempFromDate = (new Date(tempFromDate) / 1000) + 61200
                    setPaidDateValue(tempFromDate)
                  }}
                />
                <div style={{ display: 'flex', justifyContent: 'end', marginTop: '25px' }}>
                  <button
                    className="cancel-button"
                    onClick={() => {
                      setDefaultDateValue(new Date(todayDate))
                      let tempFromDate = (moment(todayDate)).valueOf()
                      tempFromDate = Math.trunc(tempFromDate / 1000) + 61200
                      setPaidDateValue(tempFromDate)
                      setPayModal(false)
                    }}>No</button>
                  <button
                    className="buttonStyle"
                    onClick={() => {
                      setDefaultDateValue(new Date(todayDate))
                      let tempFromDate = (moment(todayDate)).valueOf()
                      tempFromDate = Math.trunc(tempFromDate / 1000) + 61200
                      setPaidDateValue(tempFromDate)
                      setPayModal(false)
                      callBackInvoice(apiPayloadTempSave, paidDateValue)
                    }}>Yes</button>
                </div>
              </div>
            </ModalBody>
          </PaidDateModal>
        </Modal>
      </>
    </InvoiceTableContainer>
  );
};

export default InvoiceTable;
